import React, { Suspense } from 'react';
import Navbar from './components/NavBar.js';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import Welcome from './sections/Welcome.js';
import AboutHunt from './sections/abouthunt.js';
import Contact from './sections/Contact.js';
import Testimonials from './sections/Testimonials.js';
import tghLogo from './assets/TGHLogo.png';
import './App.css';
const MainGallery = React.lazy(() => import('./sections/MainGallery.js'));

function App() {
  return (
    <div className="App">
      <Navbar />
      <Box
        minHeight={{ xs: '44vh', md: '90vh' }}
        width="100%"
        sx={{
          backgroundColor: 'black',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <Container>
          <Grid container item xs={12} md={12}>
            <Grid item xs={6} md={6} pt={6} pb={6}>
              <img src={tghLogo} alt="Logo" style={{ width: '100%' }} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Card
        className="landing-content"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 8 },
          mt: { xs: 8, lg: -8 },
          mb: 4,
          borderRadius: 2,
          boxShadow: 3,
          display: 'block',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          lineHeight: 1.5,
        }}
      >
        <Welcome sx={{ width: '100%' }} />
        <AboutHunt />
        <Contact />
        <Testimonials />
        <Suspense fallback={<div>Loading Gallery...</div>}>
          <MainGallery />
        </Suspense>
      </Card>
    </div>
  );
}

export default App;
